var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuHotdog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99967 3.5C5.72353 3.5 5.49967 3.72386 5.49967 4C5.49967 4.27614 5.72353 4.5 5.99967 4.5H9.99967C10.2758 4.5 10.4997 4.27614 10.4997 4C10.4997 3.72386 10.2758 3.5 9.99967 3.5H5.99967Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 7.5C3.05687 7.5 2.83301 7.72386 2.83301 8C2.83301 8.27614 3.05687 8.5 3.33301 8.5H12.6663C12.9425 8.5 13.1663 8.27614 13.1663 8C13.1663 7.72386 12.9425 7.5 12.6663 7.5H3.33301Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99967 11.5C5.72353 11.5 5.49967 11.7239 5.49967 12C5.49967 12.2761 5.72353 12.5 5.99967 12.5H9.99967C10.2758 12.5 10.4997 12.2761 10.4997 12C10.4997 11.7239 10.2758 11.5 9.99967 11.5H5.99967Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHotdog);
export default __webpack_public_path__ + "static/media/MenuHotdog.2a11390a45bdeac1256ea0304cf1db45.svg";
export { ForwardRef as ReactComponent };